import React from "react";
import Dbm from "dbm";
import Website from "../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class GameHolder extends Dbm.react.BaseObject {
    _construct() {
        super._construct();

        this._openFullscreen_bound = this._openFullscreen.bind(this)

        this._element = document.createElement("div");
        this.item.setValue("holder", null);
        this.item.setValue("scale", 1);
        this.item.setValue("showForm", false);

        this.item.setValue("name", "");
        this.item.setValue("email", "");
        this.item.setValue("termsChecked", false);

        this._textSizeElement = document.createElement("div");
        this._textSizeElement.style.setProperty("font-family", "'Press Start 2P'");
        this._textSizeElement.style.setProperty("position", "absolute");
        this._textSizeElement.style.setProperty("overflow", "hidden");
        this._textSizeElement.style.setProperty("width", "0px");
        this._textSizeElement.style.setProperty("height", "0px");
        this._textSizeElement.innerText = "A true tale of tillväxt";

        let all = Dbm.flow.updatefunctions.logic.allAtValue(Dbm.loading.LoadingStatus.LOADED);

        //let pixiLoader = Dbm.loading.loadScript("https://cdn.jsdelivr.net/npm/pixi.js@8/dist/pixi.min.js");
        //let pixiSoundLoader = Dbm.loading.loadScript("https://unpkg.com/@pixi/sound@6.0.1/dist/pixi-sound.js");
        //let matterLoader = Dbm.loading.loadScript("https://cdn.jsdelivr.net/npm/matter-js@0.19.0/build/matter.min.js");

        all.addCheck(Dbm.loading.loadFont("https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap", "Press Start 2P").item.properties.status);
        all.addCheck(Dbm.loading.loadScript(build.assetsPath + "js/pixi.min.js").item.properties.status);
        //all.addCheck(Dbm.loading.loadScript("/assets/js/pixi-sound.js").item.properties.status);
        all.addCheck(Dbm.loading.loadScript(build.assetsPath + "js/matter.min.js").item.properties.status);
        

        Dbm.flow.runWhenMatched(all.output.properties.value, true, Dbm.commands.callFunction(this._baseLoaded.bind(this)));

        
        let windowSize = new Dbm.flow.updatefunctions.dom.WindowSize();
        this.item.setValue("windowSize", windowSize);
        windowSize.start();
        
        let elementSize = new Dbm.flow.updatefunctions.dom.ElementSize();
        this.item.setValue("elementSize", elementSize);

        elementSize.input.properties.element.connectInput(this.item.properties.holder);
        elementSize.start();

        let height = Website.game.Sizes.HEIGHT;
        /*
        let scaleTransform = Dbm.flow.updatefunctions.basic.transformValue(elementSize.output.properties.width, function(aValue) {
            return Math.max(1, Math.floor(aValue/Website.game.Sizes.WIDTH));
        });
        */
        let scaleTransform = Dbm.flow.dynamicUpdateFunction(function() {
            let realXScale = Math.max(1, this.input.width/Website.game.Sizes.WIDTH);
            let realYScale = Math.max(2, this.input.height/Website.game.Sizes.HEIGHT);

            let xScale = Math.floor(realXScale);
            let yScale = Math.floor(realYScale);

            if(Dbm.repository.getItem("site").gameMode === "arcade") {
                let scale = Math.min(realXScale, realYScale);
                this.output.value = scale
                this.output.centerStyle = {"height": Math.round(0.5*(this.input.height-scale*Website.game.Sizes.HEIGHT)) + "px"};
            }
            else {
                this.output.value = Math.min(xScale, yScale);
                this.output.centerStyle = {};
            }
            
        }, {"width": null, "height": null}, {"value": null, "centerStyle": {}});

        this.item.setValue("scaleTransform", scaleTransform);

        scaleTransform.input.properties.width.connectInput(elementSize.output.properties.width);
        scaleTransform.input.properties.height.connectInput(windowSize.output.properties.height);

        this.item.properties.scale.connectInput(scaleTransform.output.properties.value);

        this.scale = 3;

        let formTransform = Dbm.flow.dynamicUpdateFunction(function() {

            let fontSize = (8 + (this.input.scale-1)*3);
            let holderStyle = {
                "position": "absolute",
                "width": (230*this.input.scale) + "px",
                "fontSize": fontSize + "px",
                "top": (60*this.input.scale) + "px",
                "left": "50%",
                "font-family": "'Press Start 2P'",
                "transform": "translate(-50%, 0)"
            }

            if(this.input.scale === 1) {
                let scale = 0.4;
                holderStyle["top"] = (60*this.input.scale*scale) + "px",
                holderStyle["width"] = (230*this.input.scale/scale) + "px",
                holderStyle["transform"] = "translate(-50%, 0) scale(" + scale + ")"
            }
            if(this.input.scale === 2) {
                let scale = 0.8;
                holderStyle["top"] = (60*this.input.scale*scale) + "px",
                holderStyle["width"] = (230*this.input.scale/scale) + "px",
                holderStyle["transform"] = "translate(-50%, 0) scale(" + scale + ")"
            }

            this.output.holderStyle = holderStyle;
        }, {"scale": null}, {"holderStyle": null});

        this.item.setValue("formTransform", formTransform);

        formTransform.input.properties.scale.connectInput(this.item.properties.scale);
    }

    async _baseLoaded() {
        let all = Dbm.flow.updatefunctions.logic.allAtValue(Dbm.loading.LoadingStatus.LOADED);

        //let pixiLoader = Dbm.loading.loadScript("https://cdn.jsdelivr.net/npm/pixi.js@8/dist/pixi.min.js");
        //let pixiSoundLoader = Dbm.loading.loadScript("https://unpkg.com/@pixi/sound@6.0.1/dist/pixi-sound.js");
        //let matterLoader = Dbm.loading.loadScript("https://cdn.jsdelivr.net/npm/matter-js@0.19.0/build/matter.min.js");

        //all.addCheck(Dbm.loading.loadScript("/assets/js/pixi.min.js").item.properties.status);
        all.addCheck(Dbm.loading.loadScript(build.assetsPath + "js/pixi-sound.js").item.properties.status);
        //all.addCheck(Dbm.loading.loadScript("/assets/js/matter.min.js").item.properties.status);

        Dbm.flow.runWhenMatched(all.output.properties.value, true, Dbm.commands.callFunction(this._scriptLoaded.bind(this)));
    }

    async _scriptLoaded() {
        //console.log("_scriptLoaded");

        let game = new Website.game.Game();
        this.item.setValue("game", game.item);
        game.item.properties.scale.connectInput(this.item.properties.scale);
        game.item.setValue("fullscreenElement", this.item.fullscreenElement);
        await game.setup();
        this._element.appendChild(game.item.pixiApplication.view);
        game.item.pixiApplication.view.style.setProperty("margin", "auto");
        game.item.pixiApplication.view.style.setProperty("display", "block");
        await game.start();

        this.item.properties.showForm.connectInput(game.item.properties.showHighscoreForm);
        this.item.properties.name.connectInput(game.item.properties.name);
        this.item.properties.email.connectInput(game.item.properties.email);
        this.item.properties.termsChecked.connectInput(game.item.properties.termsChecked);

        if(Dbm.repository.getItem("site").gameMode === "arcade") {
            document.body.style.setProperty("background-color", "#000000");
        }

        this.item.fullscreenElement.addEventListener('click', this._openFullscreen_bound, true);
    }

    componentDidMount() {
        //console.log("componentDidMount");
        let parentElement = this.item.holder;
        parentElement.appendChild(this._element);
        parentElement.appendChild(this._textSizeElement);
    }

    componentDidUpdate() {
        //console.log("componentDidUpdate");
        let parentElement = this.item.holder;
        parentElement.appendChild(this._element);
        parentElement.appendChild(this._textSizeElement);
    }

    _openFullscreen(aEvent) {;
        //console.log("_openFullscreen");
        //console.log(aEvent.isTrusted);

        if(this.item.fullscreenElement.requestFullscreen) {
            let openPromise = this.item.fullscreenElement.requestFullscreen({ navigationUI: 'hide' });
            if(openPromise) {
                openPromise.then(function() {
                    
                }).catch(function(theError) {
                    console.log(theError);
                }) 
            }
        }
        
        this.item.fullscreenElement.removeEventListener('click', this._openFullscreen_bound, true);
    }

    _renderMainElement() {
        return this._createMainElement("div", {"style": {"position": "relative", "WebkitTextSizeAdjust": "100%", "textSizeAdjust": "100%"}, "ref": this.createRef("fullscreenElement")},
            <Dbm.react.BaseObject style={this.item.scaleTransform.output.properties.centerStyle}></Dbm.react.BaseObject>,
            <div ref={this.createRef("holder")} />,
            <Dbm.react.area.HasData check={this.item.properties.showForm}>
                <Dbm.react.BaseObject style={this.item.formTransform.output.properties.holderStyle}>
                    <div>Ditt namn (visas på topplistan)</div>
                    <Dbm.react.form.FormField value={this.item.properties.name} style={{"width": "100%", "fontSize": "16px", "fontFamily": "'Press Start 2P'", "padding": "4px", "marginTop": "4px", "boxSizing": "border-box"}}/>
                    <div style={{"marginTop": "10px"}}>E-post</div>
                    <Dbm.react.form.FormField value={this.item.properties.email} style={{"width": "100%", "fontSize": "16px", "fontFamily": "'Press Start 2P'", "padding": "4px", "marginTop": "4px", "boxSizing": "border-box"}} />
                    <div style={{"marginTop": "10px"}}><Dbm.react.form.Checkbox checked={this.item.properties.termsChecked} /> Jag godkänner lagring av personuppgifter enligt <a href="https://www.svensktnaringsliv.se/dataskydd/" target="_blank">integritetspolicyn</a></div>
                </Dbm.react.BaseObject>
            </Dbm.react.area.HasData>
        );
    }
}